var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-send",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-send1",
    serifid: "iconB-send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.759,14.241l-6.603,-2.567c-0.514,-0.2 -0.842,-0.344 -1.033,-0.475c-0.228,-0.155 -0.366,-0.327 -0.455,-0.499c-0.224,-0.429 -0.224,-0.94 -0.001,-1.369c0.089,-0.172 0.227,-0.344 0.454,-0.5c0.191,-0.13 0.519,-0.275 1.033,-0.475l16.703,-6.518c0.474,-0.186 0.787,-0.291 1.004,-0.322c0.253,-0.036 0.458,-0.009 0.635,0.051c0.443,0.147 0.79,0.494 0.937,0.936c0.06,0.177 0.087,0.383 0.051,0.636c-0.031,0.217 -0.136,0.53 -0.322,1.004l-6.518,16.703c-0.2,0.514 -0.345,0.842 -0.476,1.033c-0.155,0.227 -0.327,0.365 -0.499,0.454c-0.429,0.223 -0.94,0.223 -1.369,-0.001c-0.172,-0.089 -0.343,-0.227 -0.499,-0.455c-0.131,-0.191 -0.275,-0.519 -0.475,-1.033l-2.567,-6.603Zm-5.413,-4.227l5.934,2.308l7.582,-7.583l-13.516,5.275Zm14.915,-3.876l-7.583,7.582l2.308,5.934l5.275,-13.516Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBSend);
export default __webpack_public_path__ + "static/media/iconB-send.ee24bb4121380d2b63adad06a0060583.svg";
export { ForwardRef as ReactComponent };